import {
  GET_SHIPPED_QUANTITIES,
  GET_SHIPPED_QUANTITIES_SUCCESS,
  GET_SHIPPED_QUANTITIES_FAILURE,
  GET_AVERAGE_DELIVERY_DAYS,
  GET_AVERAGE_DELIVERY_DAYS_SUCCESS,
  GET_AVERAGE_DELIVERY_DAYS_FAILURE,
  GET_QUANTITIES_BY_STATE,
  GET_QUANTITIES_BY_STATE_FAILURE,
  GET_QUANTITIES_BY_STATE_SUCCESS,
  GET_SHIPPED_QUANTITIES_BY_CARRIER,
  GET_SHIPPED_QUANTITIES_BY_CARRIER_SUCCESS,
  GET_SHIPPED_QUANTITIES_BY_CARRIER_FAILURE,
  GET_SHIPPED_ITEMS_QUANTITIES,
  GET_SHIPPED_ITEMS_QUANTITIES_SUCCESS,
  GET_SHIPPED_ITEMS_QUANTITIES_FAILURE,
  GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES,
  GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES_SUCCESS,
  GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES_FAILURE,
  GET_PROCESSED_ITEMS_NATURES_QUANTITIES,
  GET_PROCESSED_ITEMS_NATURES_QUANTITIES_SUCCESS,
  GET_PROCESSED_ITEMS_NATURES_QUANTITIES_FAILURE,
  GET_REASONS_QUANTITIES,
  GET_REASONS_QUANTITIES_SUCCESS,
  GET_REASONS_QUANTITIES_FAILURE,
  GET_RECEPTION_QUANTITIES,
  GET_RECEPTION_QUANTITIES_SUCCESS,
  GET_RECEPTION_QUANTITIES_FAILURE,
  GET_EXPECTED_PRODUCTS_QUANTITIES,
  GET_EXPECTED_PRODUCTS_QUANTITIES_SUCCESS,
  GET_EXPECTED_PRODUCTS_QUANTITIES_FAILURE,
  GET_ACTUAL_PRODUCTS_QUANTITIES,
  GET_ACTUAL_PRODUCTS_QUANTITIES_SUCCESS,
  GET_ACTUAL_PRODUCTS_QUANTITIES_FAILURE,
  GET_PROCESSED_QUANTITIES,
  GET_PROCESSED_QUANTITIES_SUCCESS,
  GET_PROCESSED_QUANTITIES_FAILURE,
  GET_EXCHANGES_FOLLOWED_BY_REFUNDS_QUANTITY_SUCCESS,
  GET_MULTIPLE_EXCHANGES_QUANTITY_SUCCESS,
  GET_AVERAGE_DELIVERY_DAYS_TOP,
  GET_AVERAGE_DELIVERY_DAYS_TOP_SUCCESS,
  GET_AVERAGE_DELIVERY_DAYS_TOP_FAILURE,
  GET_SHIPPED_QUANTITIES_TOP,
  GET_SHIPPED_QUANTITIES_TOP_SUCCESS,
  GET_SHIPPED_QUANTITIES_TOP_FAILURE
} from './dashboardActions';

const initialState = {
  shippedQuantities: [],
  shippedQuantitiesTop: [],
  loadingShippedQuantities: true,
  loadingShippedQuantitiesTop: true,
  averageDeliveryDays: {
    averageByCountries: []
  },
  averageDeliveryDaysTop: {
    averageByCountries: []
  },
  multipleExchangesQuantity: 0,
  exchangesFollowedByRefundsQuantity: 0,
  loadingAverageDeliveryDaysTop: true,
  loadingAverageDeliveryDays: true,
  quantitiesByStates: [],
  loadingQuantitiesByState: true,
  shippedQuantitiesByCarrier: [],
  loadingShippedQuantitiesByCarrier: true,
  shippedItemsQuantities: [],
  loadingShippedItemsQuantities: true,
  reasonsQuantities: [],
  loadingReasonsQuantities: true,
  receptionQuantities: [],
  loadingReceptionQuantities: true,
  itemCharts: [],
  expectedProductsQuantities: [],
  loadingExpectedProductsQuantities: true,
  actualProductsQuantities: [],
  loadingActualProductsQuantities: true,
  processedQuantities: [],
  loadingProcessedQuantities: true,
  processedShipmentsNaturesQuantities: [],
  loadingProcessedShipmentsNaturesQuantities: true,
  loadingProcessedItemsNaturesQuantities: true
};

/**
 * Reducer de la partie dashboard
 */
const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SHIPPED_QUANTITIES:
      return {
        ...state,
        loadingShippedQuantities: true
      };
    case GET_SHIPPED_QUANTITIES_SUCCESS:
      return {
        ...state,
        shippedQuantities: action.payload.shippedQuantities,
        loadingShippedQuantities: false
      };
    case GET_SHIPPED_QUANTITIES_FAILURE:
      return {
        ...state,
        loadingShippedQuantities: false
      };
    case GET_SHIPPED_QUANTITIES_TOP:
      return {
        ...state,
        loadingShippedQuantitiesTop: true
      };
    case GET_SHIPPED_QUANTITIES_TOP_SUCCESS:
      return {
        ...state,
        shippedQuantitiesTop: action.payload.shippedQuantities,
        loadingShippedQuantitiesTop: false
      };
    case GET_SHIPPED_QUANTITIES_TOP_FAILURE:
      return {
        ...state,
        loadingShippedQuantitiesTop: false
      };
    case GET_AVERAGE_DELIVERY_DAYS:
      return {
        ...state,
        loadingAverageDeliveryDays: true
      };
    case GET_AVERAGE_DELIVERY_DAYS_SUCCESS:
      return {
        ...state,
        averageDeliveryDays: action.payload.averageDeliveryDays,
        loadingAverageDeliveryDays: false
      };
    case GET_AVERAGE_DELIVERY_DAYS_FAILURE:
      return {
        ...state,
        loadingAverageDeliveryDays: false
      };
    case GET_AVERAGE_DELIVERY_DAYS_TOP:
      return {
        ...state,
        loadingAverageDeliveryDaysTop: true
      };
    case GET_AVERAGE_DELIVERY_DAYS_TOP_SUCCESS:
      return {
        ...state,
        averageDeliveryDaysTop: action.payload.averageDeliveryDays,
        loadingAverageDeliveryDaysTop: false
      };
    case GET_AVERAGE_DELIVERY_DAYS_TOP_FAILURE:
      return {
        ...state,
        loadingAverageDeliveryDaystop: false
      };
    case GET_QUANTITIES_BY_STATE:
      return {
        ...state,
        loadingQuantitiesByStates: true
      };
    case GET_QUANTITIES_BY_STATE_FAILURE:
      return {
        ...state,
        loadingQuantitiesByStates: false
      };
    case GET_QUANTITIES_BY_STATE_SUCCESS:
      return {
        ...state,
        quantitiesByStates: action.payload.quantitiesByStates,
        loadingQuantitiesByStates: false
      };
    case GET_SHIPPED_QUANTITIES_BY_CARRIER:
      return {
        ...state,
        loadingShippedQuantitiesByCarrier: true
      };
    case GET_SHIPPED_QUANTITIES_BY_CARRIER_SUCCESS:
      return {
        ...state,
        shippedQuantitiesByCarrier: action.payload.shippedQuantities,
        loadingShippedQuantitiesByCarrier: false
      };
    case GET_SHIPPED_QUANTITIES_BY_CARRIER_FAILURE:
      return {
        ...state,
        loadingShippedQuantitiesByCarrier: false
      };
    case GET_SHIPPED_ITEMS_QUANTITIES:
      return {
        ...state,
        loadingShippedItemsQuantities: true
      };
    case GET_SHIPPED_ITEMS_QUANTITIES_SUCCESS:
      return {
        ...state,
        shippedItemsQuantities: action.payload.shippedItemsQuantities,
        loadingShippedItemsQuantities: false
      };
    case GET_SHIPPED_ITEMS_QUANTITIES_FAILURE:
      return {
        ...state,
        loadingShippedItemsQuantities: false
      };
    case GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES:
      return {
        ...state,
        loadingProcessedShipmentsNaturesQuantities: true
      };
    case GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES_SUCCESS:
      return {
        ...state,
        processedShipmentsNaturesQuantities:
          action.payload.processedShipmentsNaturesQuantities,
        loadingProcessedShipmentsNaturesQuantities: false
      };
    case GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES_FAILURE:
      return {
        ...state,
        loadingProcessedShipmentsNaturesQuantities: false
      };
    case GET_PROCESSED_ITEMS_NATURES_QUANTITIES:
      return {
        ...state,
        loadingProcessedItemsNaturesQuantities: true
      };
    case GET_PROCESSED_ITEMS_NATURES_QUANTITIES_SUCCESS:
      return {
        ...state,
        processedItemsNaturesQuantities:
          action.payload.processedItemsNaturesQuantities,
        loadingProcessedItemsNaturesQuantities: false
      };
    case GET_PROCESSED_ITEMS_NATURES_QUANTITIES_FAILURE:
      return {
        ...state,
        loadingProcessedItemsNaturesQuantities: false
      };
    case GET_REASONS_QUANTITIES:
      return {
        ...state,
        loadingReasonsQuantities: true
      };
    case GET_REASONS_QUANTITIES_SUCCESS:
      return {
        ...state,
        reasonsQuantities: action.payload.reasonsQuantities,
        loadingReasonsQuantities: false
      };
    case GET_REASONS_QUANTITIES_FAILURE:
      return {
        ...state,
        loadingReasonsQuantities: false
      };
    case GET_RECEPTION_QUANTITIES:
      return {
        ...state,
        loadingReceptionQuantities: true
      };
    case GET_RECEPTION_QUANTITIES_SUCCESS:
      return {
        ...state,
        receptionQuantities: action.payload.receptionQuantities,
        loadingReceptionQuantities: false
      };
    case GET_RECEPTION_QUANTITIES_FAILURE:
      return {
        ...state,
        loadingReceptionQuantities: false
      };

    case GET_EXPECTED_PRODUCTS_QUANTITIES:
      return {
        ...state,
        loadingExpectedProductsQuantities: true
      };
    case GET_EXPECTED_PRODUCTS_QUANTITIES_SUCCESS:
      return {
        ...state,
        expectedProductsQuantities: action.payload.expectedProductsQuantities,
        loadingExpectedProductsQuantities: false
      };
    case GET_EXPECTED_PRODUCTS_QUANTITIES_FAILURE:
      return {
        ...state,
        loadingExpectedProductsQuantities: false
      };
    case GET_ACTUAL_PRODUCTS_QUANTITIES:
      return {
        ...state,
        loadingActualProductsQuantities: true
      };
    case GET_ACTUAL_PRODUCTS_QUANTITIES_SUCCESS:
      return {
        ...state,
        actualProductsQuantities: action.payload.actualProductsQuantities,
        loadingActualProductsQuantities: false
      };
    case GET_ACTUAL_PRODUCTS_QUANTITIES_FAILURE:
      return {
        ...state,
        loadingActualProductsQuantities: false
      };
    case GET_PROCESSED_QUANTITIES:
      return {
        ...state,
        loadingProcessedQuantities: true
      };
    case GET_PROCESSED_QUANTITIES_SUCCESS:
      return {
        ...state,
        processedQuantities: action.payload.processedQuantities,
        loadingProcessedQuantities: false
      };
    case GET_PROCESSED_QUANTITIES_FAILURE:
      return {
        ...state,
        loadingProcessedQuantities: false
      };
    case GET_MULTIPLE_EXCHANGES_QUANTITY_SUCCESS:
      return {
        ...state,
        multipleExchangesQuantity: action.payload.multipleExchangesQuantity
      };
    case GET_EXCHANGES_FOLLOWED_BY_REFUNDS_QUANTITY_SUCCESS:
      return {
        ...state,
        exchangesFollowedByRefundsQuantity:
          action.payload.exchangesFollowedByRefundsQuantity
      };
    default:
      return state;
  }
};

export default dashboardReducer;
